/**
 * Imported listing titles usually lead with the brand ("Sony WH-1000XM4"), so a
 * separate brand line under them reads "Sony WH-1000XM4 / Sony" (GET-136). Show
 * the brand line only when the title doesn't already start with it as a word.
 */
export function shouldShowBrandLine(title: string, brand: string | null | undefined): boolean {
  const b = brand?.trim().toLowerCase();
  if (!b) return false;
  const t = title.trim().toLowerCase();
  if (!t.startsWith(b)) return true;
  const next = t.charAt(b.length);
  return next !== '' && /[a-z0-9]/.test(next);
}
